module.exports = __webpack_public_path__ + "img/flux-logo.c4075466.svg";